
export function _slideUp(target, duration = 500) {
	if (target.classList.contains('_slide')) return
	target.classList.add('_slide')

	target.style.transitionProperty = 'height, margin, padding'
	target.style.transitionDuration = duration + 'ms'
	target.style.height = target.offsetHeight + 'px'
	target.offsetHeight
	target.style.overflow = 'hidden'
	target.style.height = 0
	target.style.paddingTop = 0
	target.style.paddingBottom = 0
	target.style.marginTop = 0
	target.style.marginBottom = 0

	window.setTimeout(() => {
		target.hidden = true
		cleanStyles(target)
		target.classList.remove('_slide')
	}, duration)
}

export function _slideDown(target, duration = 500) {
	if (target.classList.contains('_slide')) return
	target.classList.add('_slide')

	if (target.hidden) target.hidden = false
	let height = target.scrollHeight

	target.style.overflow = 'hidden'
	target.style.height = 0
	target.style.paddingTop = 0
	target.style.paddingBottom = 0
	target.style.marginTop = 0
	target.style.marginBottom = 0
	target.offsetHeight

	target.style.transitionProperty = 'height, margin, padding'
	target.style.transitionDuration = duration + 'ms'
	target.style.height = height + 'px'
	target.style.removeProperty('padding-top')
	target.style.removeProperty('padding-bottom')
	target.style.removeProperty('margin-top')
	target.style.removeProperty('margin-bottom')

	window.setTimeout(() => {
		cleanStyles(target)
		target.classList.remove('_slide')
	}, duration)
}

export function cleanStyles(target) {
	target.style.removeProperty('height')
	target.style.removeProperty('overflow')
	target.style.removeProperty('transition-duration')
	target.style.removeProperty('transition-property')
	target.style.removeProperty('padding-top')
	target.style.removeProperty('padding-bottom')
	target.style.removeProperty('margin-top')
	target.style.removeProperty('margin-bottom')
}
